import "styles/Form.scss";

const formWrapper = (WrappedComponent) => {
    const wrapper = props => {
        return (props.modal) ? (
            <WrappedComponent {...props} />
        ) : (
            <div className={"form-container"}>
                <WrappedComponent {...props} />
            </div>
        )
    }
    wrapper.model = WrappedComponent.model
    if (WrappedComponent.disableLanguages) {
        wrapper.disableLanguages = WrappedComponent.disableLanguages
    }
    if (WrappedComponent.disableTypes) {
        wrapper.disableTypes = WrappedComponent.disableTypes
    }
    return wrapper;
}

export default formWrapper